import 'babel-polyfill'
import '@grapecity/ar-viewer/dist/jsViewer.min.js'
import '@grapecity/ar-viewer/dist/jsViewer.min.css'

import Vue from 'vue'
import Vuex from 'vuex'
import VueLoading from 'vuex-loading'
import VueClipboards from 'vue-clipboards'
import BootstrapVue from 'bootstrap-vue'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Wysiwyg from 'vue-wysiwyg'
import 'vue-wysiwyg/dist/vueWysiwyg.css'
import VueCal from 'vue-cal'
import 'vue-cal/dist/vuecal.css'
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'
import HighchartsMore from 'highcharts/highcharts-more'

import app from '@/App'
import store from '@/store'
import router from '@/router'
import filters from '@/filters'

import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required, oneOf, email, min, max, length } from 'vee-validate/dist/rules'
// Vee Validate Rules
extend('required', {
  ...required,
  message: 'This field is required'
})
extend('oneOf', {
  ...oneOf,
  message: 'This field is required'
})
extend('email', {
  ...email,
  message: 'Required, formatted email address'
})
extend('min', min)
extend('max', max)
extend('length', length)

// for Bootstrap
Vue.use(BootstrapVue)

// production tips
Vue.config.productionTip = false

// vuex
Vue.use(Vuex)

// use filters
Vue.use(filters)

// vue loading
Vue.use(VueLoading)

// use copy
Vue.use(VueClipboards)

// Vue Form Wizard
Vue.use(VueFormWizard)

Vue.use(VueCal)

Vue.use(Wysiwyg, {
  hideModules: { code: true, image: true },
  maxHeight: '500px',
  forcePlainTextOnPaste: true
})

HighchartsMore(Highcharts)
Vue.use(HighchartsVue)

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)

window.eventBus = Vue.prototype.$eventBus = new Vue()

/* eslint-disable no-new */
window.vueApp = new Vue({
  store,
  router,
  el: '#app',
  template: '<app/>',
  components: { app },
  vueLoading: new VueLoading({ useVuex: true })
})



// WEBPACK FOOTER //
// ./src/main.js